import { render, staticRenderFns } from "./PrivilegeCampaignList.vue?vue&type=template&id=6f8e52c6&"
import script from "./PrivilegeCampaignList.vue?vue&type=script&lang=js&"
export * from "./PrivilegeCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeCampaignList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports